import React, { memo } from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a1400] py-16 px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <div className="text-center mb-10" data-id="element-70">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-71">
            📋 ¿Qué agrega{' '}
            <span className="text-[#FFD700]" data-id="element-72">
              Adaptaciones para el Aula Real
            </span>
            ?
          </h2>
          <p className="text-gray-300 text-base max-w-2xl mx-auto" data-id="element-73">
            Vos ya tenés el material para planificar y dar el año completo.
            Adaptaciones para el Aula Real resuelve lo que pasa cuando la
            realidad del aula no coopera.
          </p>
        </div>

        {/* Compact Comparison */}
        <div className="bg-black border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-10" data-id="element-74">
          <div className="grid grid-cols-3 bg-[#0d0a00] border-b border-[#FFD700]/30" data-id="element-75">
            <div className="p-3 font-bold text-white text-sm" data-id="element-76">Situación</div>
            <div className="p-3 font-bold text-gray-400 text-sm text-center border-l border-[#FFD700]/30" data-id="element-77">
              Sin Adaptaciones
            </div>
            <div className="p-3 font-bold text-[#FFD700] text-sm text-center border-l border-[#FFD700]/30" data-id="element-78">
              Con Adaptaciones
            </div>
          </div>
          {[['Grupo heterogéneo con niveles muy distintos', 'Enseñás para el promedio y perdés a todos', 'Estrategias concretas por escenario listas para aplicar'], ['Alumno que no lee bien o no participa', 'Improvisás o ignorás el problema', 'Guiones exactos y recursos adaptados para esa realidad'], ['Contexto vulnerable o aula difícil', 'Llegás sin saber cómo arrancar', 'Frases, dinámicas y estructuras pensadas para ese contexto'], ['Semana corta por feriado o acto escolar', 'Cancelás o improvisás algo sin sentido', 'Kit de clase de 10 y 20 minutos listo para usar'], ['Clase de 40 minutos vs clase de 80 minutos', 'Usás lo mismo y queda mal en los dos', 'Estructuras diferenciadas para cada duración'], ['Situación difícil que no esperabas', 'Respondés mal o te quedás en blanco', 'Guión exacto para manejarla sin perder el hilo']].map(([situation, without, withEco], i) => <div key={i} className="grid grid-cols-3 border-b border-gray-800 last:border-b-0" data-id="element-79">
              <div className="p-3 text-white text-xs sm:text-sm" data-id="element-80">
                {situation}
              </div>
              <div className="p-3 text-gray-500 text-xs sm:text-sm border-l border-gray-800 bg-gray-900/30" data-id="element-81">
                {without}
              </div>
              <div className="p-3 text-white text-xs sm:text-sm border-l border-gray-800 bg-[#FFD700]/5" data-id="element-82">
                {withEco}
              </div>
            </div>)}
        </div>

        {/* Compact Modules List */}
        <div className="bg-black border border-[#FFD700]/20 rounded-2xl p-6" data-id="element-83">
          <h3 className="text-xl font-black text-white text-center mb-5" data-id="element-84">
            ✅ ADAPTACIONES PARA EL AULA REAL INCLUYE:
          </h3>
          <div className="space-y-3" data-id="element-85">
            <div className="flex items-start gap-3" data-id="element-86">
              <span className="text-lg" data-id="element-87">⚡</span>
              <p className="text-sm text-white" data-id="element-88">
                <span className="font-bold" data-id="element-89">Estrategias por Escenario</span>{' '}
                <span className="text-gray-400" data-id="element-90">
                  · Pasos concretos para grupos heterogéneos, multigrado, baja
                  participación y contextos vulnerables.
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-91">
              <span className="text-lg" data-id="element-92">🗣️</span>
              <p className="text-sm text-white" data-id="element-93">
                <span className="font-bold" data-id="element-94">Guiones y Frases Exactas</span>{' '}
                <span className="text-gray-400" data-id="element-95">
                  · Las palabras justas para arrancar, sostener y cerrar cada
                  clase sin improvisar.
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-96">
              <span className="text-lg" data-id="element-97">⏱️</span>
              <p className="text-sm text-white" data-id="element-98">
                <span className="font-bold" data-id="element-99">
                  Estructuras de Clase para 40 y 80 Minutos
                </span>{' '}
                <span className="text-gray-400" data-id="element-100">
                  · Dos estructuras distintas con tiempos, participación y
                  cierre adaptados.
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-101">
              <span className="text-lg" data-id="element-102">📋</span>
              <p className="text-sm text-white" data-id="element-103">
                <span className="font-bold" data-id="element-104">
                  Kits de Clase Corta — 10 y 20 Minutos
                </span>{' '}
                <span className="text-gray-400" data-id="element-105">
                  · Clase completa y con sentido para semanas cortas por
                  feriados o imprevistos.
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-106">
              <span className="text-lg" data-id="element-107">📁</span>
              <p className="text-sm text-white" data-id="element-108">
                <span className="font-bold" data-id="element-109">Casos Completos ya Redactados</span>{' '}
                <span className="text-gray-400" data-id="element-110">
                  · Situaciones reales ya desarrolladas. Adaptás y usás directo,
                  sin armar desde cero.
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-111">
              <span className="text-lg" data-id="element-112">📄</span>
              <p className="text-sm text-white" data-id="element-113">
                <span className="font-bold" data-id="element-114">100% en PDF</span>{' '}
                <span className="text-gray-400" data-id="element-115">
                  · Descargás una vez, es tuyo para siempre. Sin internet ni
                  plataformas.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}